import {
  LOADING_LOGIN,
  SET_USER,
  ERROR_LOGIN,
  LOGOUT,
  SWITCH_ADMIN_MENU,
} from './ActionTypes';
import fire from '../utils/firebase/firebase';
import * as firebase from 'firebase';

export const register = async (dispatch, email, password, name) => {
  dispatch({ type: LOADING_LOGIN });
  try {
    const result = await fire
      .auth()
      .createUserWithEmailAndPassword(email, password);
    result.user.updateProfile({
      displayName: name,
    });
    // Url de redirección
    const config = {
      url: 'http://localhost:3000',
    };
    await result.user.sendEmailVerification(config);
    // We close session because Firebase signin by default when register
    fire.auth().signOut();
  } catch (error) {
    dispatch({ type: ERROR_LOGIN, payload: error.message });
  }
};

export const registerGoogle = async (dispatch) => {
  dispatch({ type: LOADING_LOGIN });
  try {
    const provider = new firebase.auth.GoogleAuthProvider();
    fire.auth().languageCode = 'es';

    await firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(async function () {
        // Existing and future Auth states are now persisted in the current
        // session only. Closing the window would clear any existing state even
        // if a user forgets to sign out.
        // ...
        // New sign-in will be persisted with session persistence.

        return fire.auth().signInWithPopup(provider);
      })
      .catch(function (error) {
        // Handle Errors here.
        console.log(error);
      });

    fire.auth().signOut();
    dispatch({
      type: ERROR_LOGIN,
      payload:
        'Debe notificar al desarrollador del sitio para que active su cuenta',
    });
  } catch (error) {
    dispatch({ type: ERROR_LOGIN, payload: error.message });
  }
};

export const loginWithEmailPassword = async (dispatch, email, password) => {
  dispatch({ type: LOADING_LOGIN });
  try {
    const result = await fire
      .auth()
      .signInWithEmailAndPassword(email, password);
    // Email was verified?
    if (result.user.emailVerified) {
      dispatch({ type: SWITCH_ADMIN_MENU, payload: 'programas' });
      dispatch({
        type: SET_USER,
        payload: {
          user: email,
          photoURL: result.user.photoURL,
          displayName: result.user.displayName,
        },
      });
    } else {
      fire.auth().signOut();
      dispatch({ type: ERROR_LOGIN, payload: 'Debe verificar su correo.' });
    }
  } catch (error) {
    dispatch({ type: ERROR_LOGIN, payload: error.message });
  }
};

export const loginGoogle = async (dispatch) => {
  dispatch({ type: LOADING_LOGIN });
  try {
    const provider = new firebase.auth.GoogleAuthProvider();
    fire.auth().languageCode = 'es';

    const result = await firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(async function () {
        // Existing and future Auth states are now persisted in the current
        // session only. Closing the window would clear any existing state even
        // if a user forgets to sign out.
        // ...
        // New sign-in will be persisted with session persistence.

        return fire.auth().signInWithPopup(provider);
      })
      .catch(function (error) {
        // Handle Errors here.
        console.log(error);
      });

    if (result.user.emailVerified) {
      // The signed-in user info.
      const user = result.user;
      dispatch({ type: SWITCH_ADMIN_MENU, payload: 'programas' });
      dispatch({
        type: SET_USER,
        payload: {
          email: user.email,
          avatar: user.photoURL,
          displayName: user.displayName,
        },
      });
    } else {
      fire.auth().signOut();
      dispatch({ type: ERROR_LOGIN, payload: 'Debe verificar su correo.' });
    }
  } catch (error) {
    dispatch({ type: ERROR_LOGIN, payload: error.message });
  }
};

export const logout = async (dispatch) => {
  dispatch({ type: LOADING_LOGIN });
  try {
    await fire.auth().signOut();
    dispatch({ type: LOGOUT });
  } catch (error) {
    dispatch({ type: ERROR_LOGIN, payload: error.message });
  }
};
